import config from "../../config";
import ButtonV2 from "../../components/ButtonV2";
import { Link } from "react-router-dom";

const NewsSmall = (props) => {
  // z props dostaneme dvě aktuality (bohuzel takoveto reseni kvuli slideru)
  const { news } = props;

  return (
    <div className="d-flex flex-row flex-lg-column">
      {/* generovani aktuality pokud je prevzata z props jinak default */}
      {news[0] ? (
        <div className="col-lg-12 col-6 news-small-background d-flex flex-column flex-lg-row">
          <img
            src={`${config.api}${news[0].image.url}`}
            alt={news[0].image.alternativeText}
            className="col-12 col-lg-6 p-2"
          />
          <div className="col-12 col-lg-6 d-flex flex-column p-2">
            <h3>
              {news[0].name.slice(0, 40)}
              {news[0].name.length > 40 ? "..." : ""}
            </h3>
            {/* <p>{news[0].attributes.overview.slice(0, 50)}</p> */}

            <Link to={`/aktuality/detail/${news[0].documentId}`}>
              <ButtonV2 text="Více" />
            </Link>
          </div>
        </div>
      ) : (
        <div className="col-lg-12 col-6 news-small-background d-flex flex-column flex-lg-row">
          <div className="col-12 col-lg-6 d-flex flex-column">
            <h4>No Title</h4>
            <p>No Description</p>
            <ButtonV2 text="vice" />
          </div>
        </div>
      )}
      {/* generovani aktuality pokud je prevzata z props jinak default */}
      {news[1] ? (
        <div className="col-lg-12 col-6 news-small-background d-flex flex-column flex-lg-row mt-lg-2 ms-1">
          <img
            src={`${config.api}${news[1].image.url}`}
            alt={news[1].image.alternativeText}
            className="col-12 col-lg-6 p-2"
          />
          <div className="col-12 col-lg-6 d-flex flex-column p-2">
            <h3>
              {news[1].name.slice(0, 40)}
              {news[1].name.length > 40 ? "..." : ""}
            </h3>
            {/* <p>{news[1].attributes.overview.slice(0, 50)}</p> */}
            <Link to={`/aktuality/detail/${news[1].documentId}`}>
              <ButtonV2 text="Více" />
            </Link>
          </div>
        </div>
      ) : (
        <div className="col-lg-12 col-6 news-small-background d-flex flex-column flex-lg-row">
          <div className="col-12 col-lg-6 d-flex flex-column">
            <h4>No Title</h4>
            <p>No Description</p>
            <ButtonV2 text="vice" />
          </div>
        </div>
      )}
    </div>
  );
};

export default NewsSmall;

